import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Sparkles } from 'lucide-react';
const slides = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/hU6CdcejzLexGyjRbpxkUR/slide1.png',
  alt: 'Máster de la Voz',
  category: 'Voz y Autoridad',
  isPlaceholder: false
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/rAN4vWBCdQV1c55NaUKBXk/slide2.png',
  alt: 'Tu Aura Digital',
  category: 'Marca Personal',
  isPlaceholder: false
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/hPz57k5YwZrQnXZsycqAFz/slide3.png',
  alt: 'Lenguaje Corporal',
  category: 'Presencia',
  isPlaceholder: false
}, {
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/fGEmjHTnnGyHr4HXhGBYgk/slide4.png',
  alt: 'Comunicación Magnética',
  category: 'Influencia',
  isPlaceholder: false
}, {
  id: 5,
  image: 'https://cdn.magicpatterns.com/uploads/i862BLAwVDUpgx9gy7jq3t/slide5.png',
  alt: 'Historias Magnéticas',
  category: 'Storytelling',
  isPlaceholder: false
}, {
  id: 6,
  image: 'https://cdn.magicpatterns.com/uploads/3GenxbJzM4qc1F8T546mvp/slide6.png',
  alt: 'Home Studio Pro',
  category: 'Producción',
  isPlaceholder: false
}, {
  id: 7,
  image: 'https://cdn.magicpatterns.com/uploads/b8X737BDVWzCxiVcX2XsxX/slide7.png',
  alt: 'Domina el Escenario',
  category: 'Performance',
  isPlaceholder: false
}];
// Duplicate slides to ensure seamless infinite scrolling
const marqueeSlides = [...slides, ...slides, ...slides];
export function PromotionSlider() {
  const [isHovered, setIsHovered] = useState(false);
  return <section className="w-full bg-[#050505] py-12 border-t border-[#C9A961]/20 overflow-hidden relative" data-id="element-408">
      {/* Cinematic Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#C9A961]/5 via-transparent to-transparent opacity-40 pointer-events-none" data-id="element-409" />

      {/* Header Content - Compact */}
      <div className="max-w-7xl mx-auto px-4 mb-10 text-center relative z-10" data-id="element-410">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-411">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-412">
            <Sparkles className="w-4 h-4 text-[#C9A961]" data-id="element-413" />
            <p className="text-[#C9A961] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-414">
              Pack Premium Completo
            </p>
            <Sparkles className="w-4 h-4 text-[#C9A961]" data-id="element-415" />
          </div>
          <h2 className="text-2xl md:text-3xl font-light text-white tracking-wide" data-id="element-416">
            7 Ebooks{' '}
            <span className="text-[#C9A961] font-serif italic mx-1" data-id="element-417">
              de Poder
            </span>{' '}
            en 1 Pack
          </h2>
        </motion.div>
      </div>

      {/* Carousel Container */}
      <div className="relative w-full" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-418">
        {/* Gradient Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-[#050505] to-transparent z-20 pointer-events-none" data-id="element-419" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-[#050505] to-transparent z-20 pointer-events-none" data-id="element-420" />

        {/* Marquee Track */}
        <div className="flex overflow-hidden" data-id="element-421">
          <motion.div className="flex gap-4 md:gap-6 pl-4" animate={{
          x: ['0%', '-33.33%']
        }} transition={{
          x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 50,
            ease: 'linear'
          }
        }} style={{
          width: 'max-content',
          animationPlayState: isHovered ? 'paused' : 'running'
        }} data-id="element-422">
            {marqueeSlides.map((slide, index) => <SlideCard key={`${slide.id}-${index}`} slide={slide} data-id="element-423" />)}
          </motion.div>
        </div>
      </div>
    </section>;
}
function SlideCard({
  slide
}: {
  slide: (typeof slides)[0];
}) {
  return <motion.div className="relative group cursor-pointer" whileHover={{
    scale: 1.02,
    y: -5
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} data-id="element-424">
      {/* Card Container */}
      <div className={`w-[160px] md:w-[200px] aspect-[2/3] relative rounded-lg overflow-hidden border transition-all duration-500 ${slide.isPlaceholder ? 'bg-[#0a0a0a] border-[#C9A961]/20 group-hover:border-[#C9A961]/40' : 'bg-gray-900 border-[#C9A961]/10 group-hover:border-[#C9A961]/50'}`} data-id="element-425">
        {slide.isPlaceholder ?
      // Placeholder Design
      <div className="w-full h-full flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-426">
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-427" />
            <div className="w-12 h-12 rounded-full bg-[#C9A961]/10 flex items-center justify-center mb-3 group-hover:bg-[#C9A961]/20 transition-colors" data-id="element-428">
              <Lock className="w-5 h-5 text-[#C9A961]/60" data-id="element-429" />
            </div>
            <p className="text-[#C9A961]/40 text-xs font-medium tracking-widest uppercase text-center" data-id="element-430">
              Secreto
            </p>
          </div> :
      // Real Image Design
      <>
            <img src={slide.image} alt={slide.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-431" />

            {/* Overlay Gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-432" />

            {/* Shine Effect */}
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent -translate-x-full group-hover:animate-shine pointer-events-none" data-id="element-433" />
          </>}

        {/* Content Overlay (for both types) */}
        <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 transition-transform duration-500" data-id="element-434">
          <p className={`text-[#C9A961] text-[10px] font-medium tracking-widest uppercase mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 ${slide.isPlaceholder ? 'text-center' : ''}`} data-id="element-435">
            {slide.category}
          </p>
          <h3 className={`text-white font-light text-sm leading-tight group-hover:text-[#C9A961] transition-colors duration-300 ${slide.isPlaceholder ? 'text-center text-gray-500' : ''}`} data-id="element-436">
            {slide.alt}
          </h3>
          {!slide.isPlaceholder && <div className="w-0 group-hover:w-8 h-0.5 bg-[#C9A961] mt-2 transition-all duration-500 ease-out" data-id="element-437" />}
        </div>
      </div>

      {/* Reflection/Glow underneath */}
      <div className="absolute -bottom-4 left-4 right-4 h-4 bg-[#C9A961] blur-xl opacity-0 group-hover:opacity-20 transition-opacity duration-500 rounded-full" data-id="element-438" />
    </motion.div>;
}